export const ROLE_MAPS = {
  DASHBOARD_REAL_TIME_OVERVIEW_LIVE_CALL: 'dashboard.RealTimeOverview.LiveCall',
  DASHBOARD_REAL_TIME_OVERVIEW_CALL_ANSWER_RATE: 'dashboard.RealTimeOverview.AnswerRate',
  DASHBOARD_REAL_TIME_OVERVIEW_AVERAGE_ANSWER_TIME: 'dashboard.RealTimeOverview.AverageAnswerTime',
  DASHBOARD_REAL_TIME_OVERVIEW_TOTAL_CALLS: 'dashboard.RealTimeOverview.TotalCall',
  DASHBOARD_REAL_TIME_OVERVIEW_CLOSED_CONVERSATIONS: 'dashboard.RealTimeOverview.ClosedConversation',
  DASHBOARD_REAL_TIME_OVERVIEW_TOTAL_MESSAGES: 'dashboard.RealTimeOverview.TotalMessage',
  DASHBOARD_REAL_TIME_OVERVIEW_MISSED_CALLS: 'dashboard.RealTimeOverview.MissedCall',
  DASHBOARD_REAL_TIME_OVERVIEW_OPENED_CONVERSATIONS: 'dashboard.RealTimeOverview.OpenedConversation',

  DASHBOARD_ANALYTICS_OVERVIEW_WALLET_SPENT_BREAKDOWN: 'dashboard.AnalyticsOverview.WalletSpentBreakdown',
  DASHBOARD_ANALYTICS_OVERVIEW_CALL_VOLUME: 'dashboard.AnalyticsOverview.CallVolume',
  DASHBOARD_ANALYTICS_OVERVIEW_UNIQUE_VS_REPEATED_CALLER: 'dashboard.AnalyticsOverview.UniqueVsRepeatedCaller',
  DASHBOARD_ANALYTICS_OVERVIEW_LEADERBOARD: 'dashboard.AnalyticsOverview.Leaderboard',
  DASHBOARD_ANALYTICS_OVERVIEW_CALL_DISTRIBUTION: 'dashboard.AnalyticsOverview.CallDistribution',
  DASHBOARD_ANALYTICS_OVERVIEW_KEY_KPI: 'dashboard.AnalyticsOverview.KeyKpi',
  DASHBOARD_ANALYTICS_OVERVIEW_ACTIVITY_AFTER_BUSINESS_HOURS: 'dashboard.AnalyticsOverview.ActivityAfterBusinessHours',
  DASHBOARD_ANALYTICS_OVERVIEW_CRITICAL_EVENT: 'dashboard.AnalyticsOverview.CriticalEvent',

  // AI_REPORTS_AI_REPORTS_LIST: 'ai-reports.ai-reports.list',
  // DASHBOARD_CALL_HISTORIES_VIEW: 'dashboard.call-histories.view',
  // DASHBOARD_CONFERENCE_ANALYTICS_VIEW: 'dashboard.conference-analytics.view',
  // DASHBOARD_CONFERENCE_INTERACTIONS_VIEW: 'dashboard.conference-interactions.view',
  // DASHBOARD_LIVE_CALLS_DISCONNECT_CALLS: 'dashboard.live-calls.disconnect-calls',
  // DASHBOARD_LIVE_CALLS_HANG_UP_CONFERENCE: 'dashboard.live-calls.hang-up-conference',
  // DASHBOARD_LIVE_CALLS_SUPERVISE_CONFERENCE: 'dashboard.live-calls.supervise-conference',
  // DASHBOARD_LIVE_CALLS_VIEW: 'dashboard.live-calls.view',
  // DASHBOARD_MEMBERS_VIEW: 'dashboard.members.view',
  // DASHBOARD_MESSAGES_VIEW: 'dashboard.messages.view',
  // DASHBOARD_MOST_USED_WORDS_VIEW: 'dashboard.most-used-words.view',
  // DASHBOARD_NUMBER_REPORTS_VIEW: 'dashboard.number-reports.view',
  // DASHBOARD_TRAFFIC_BY_COUNTRIES_VIEW: 'dashboard.traffic-by-countries.view',

  CONTACTS_CONTACTS_BLOCK_UNBLOCK: 'contacts.contacts.block-unblock',
  CONTACTS_CONTACTS_CREATE: 'contacts.contacts.create',
  CONTACTS_CONTACTS_DELETE: 'contacts.contacts.delete',
  CONTACTS_CONTACTS_DETAIL: 'contacts.contacts.detail',
  CONTACTS_CONTACTS_EXPORT: 'contacts.contacts.export',
  CONTACTS_CONTACTS_IMPORT: 'contacts.contacts.import',
  CONTACTS_CONTACTS_LIST: 'contacts.contacts.list',
  CONTACTS_CONTACTS_UPDATE: 'contacts.contacts.update',
  CONTACTS_NOTES_CREATE: 'contacts.notes.create',
  CONTACTS_NOTES_DELETE: 'contacts.notes.delete',
  CONTACTS_NOTES_UPDATE: 'contacts.notes.update',
  CONTACTS_NOTES_VIEW: 'contacts.notes.view',
  CONTACTS_TAGS_ASSIGN: 'contacts.tags.assign',
  CONTACTS_TAGS_CREATE: 'contacts.tags.create',
  CONTACTS_TAGS_DELETE: 'contacts.tags.delete',
  CONTACTS_TAGS_LIST: 'contacts.tags.list',
  CONTACTS_TAGS_UNASSIGN: 'contacts.tags.unassign',
  CONTACTS_TAGS_UPDATE: 'contacts.tags.update',

  MY_NUMBERS_CHANNEL_GROUPS_ASSIGN: 'my-numbers.channel-groups.assign',
  MY_NUMBERS_CHANNEL_GROUPS_CREATE: 'my-numbers.channel-groups.create',
  MY_NUMBERS_CHANNEL_GROUPS_DELETE: 'my-numbers.channel-groups.delete',
  MY_NUMBERS_CHANNEL_GROUPS_LIST: 'my-numbers.channel-groups.list',
  MY_NUMBERS_CHANNEL_GROUPS_UNASSIGN: 'my-numbers.channel-groups.unassign',
  MY_NUMBERS_CHANNEL_GROUPS_UPDATE: 'my-numbers.channel-groups.update',
  MY_NUMBERS_CHANNEL_GROUPS_VIEW: 'my-numbers.channel-groups.view',

  POWER_DIALER_POWER_CAMPAIGN_VIEW: 'power-dialer.power-campaign.view',
  // POWER_DIALER_POWER_CAMPAIGN_CALL_HISTORY_EXPORT: 'power-dialer.power-campaign-call-history.export',
  // POWER_DIALER_POWER_CAMPAIGN_CALL_HISTORY_VIEW: 'power-dialer.power-campaign-call-history.view',
  // POWER_DIALER_POWER_CAMPAIGN_CREATE: 'power-dialer.power-campaign.create',
  // POWER_DIALER_POWER_CAMPAIGN_DELETE: 'power-dialer.power-campaign.delete',
  // POWER_DIALER_POWER_CAMPAIGN_DELETE_ROLE: 'power-dialer.power-campaign.delete-role',
  // POWER_DIALER_POWER_CAMPAIGN_LIST: 'power-dialer.power-campaign.list',
  // POWER_DIALER_POWER_CAMPAIGN_REASSIGN_POWER_CAMPAIGN_CONTACTS:
  //   'power-dialer.power-campaign.reassign-power-campaign-contacts',
  // POWER_DIALER_POWER_CAMPAIGN_UPDATE: 'power-dialer.power-campaign.update',
  // POWER_DIALER_POWER_CAMPAIGN_UPDATE_CAMPAIGN_CONTACT: 'power-dialer.power-campaign.update-campaign-contact',
  // POWER_DIALER_POWER_CAMPAIGN_VEIEWILSEJL: 'power-dialer.power-campaign.veiewilsejl',
  // POWER_DIALER_POWER_CAMPAIGN_VIEW_SCREENSSS: 'power-dialer.power-campaign.view-screensss',
  // POWER_DIALER_POWER_DIALER_ACTIVE_SESSION_VIEW: 'power-dialer.power-dialer-active-session.view',
  // POWER_DIALER_POWER_DISPOSITION_CREATE: 'power-dialer.power-disposition.create',
  // POWER_DIALER_POWER_DISPOSITION_DELETE: 'power-dialer.power-disposition.delete',
  // POWER_DIALER_POWER_DISPOSITION_DISPOSITION_CONTACTS: 'power-dialer.power-disposition.disposition-contacts',
  // POWER_DIALER_POWER_DISPOSITION_LIST: 'power-dialer.power-disposition.list',
  // POWER_DIALER_POWER_DISPOSITION_UPDATE: 'power-dialer.power-disposition.update',
  // POWER_DIALER_POWER_DISPOSITION_UPDATE_POWER_CONTACT: 'power-dialer.power-disposition.update-power-contact',
  // POWER_DIALER_POWER_DISPOSITION_VIEW: 'power-dialer.power-disposition.view',
  // POWER_DIALER_POWER_IMPORT_LISTS_CREATE: 'power-dialer.power-import-lists.create',
  // POWER_DIALER_POWER_IMPORT_LISTS_DELETE: 'power-dialer.power-import-lists.delete',
  // POWER_DIALER_POWER_IMPORT_LISTS_VIEW: 'power-dialer.power-import-lists.view',

  // SETTINGS_BILLING_ADDRESS_UPDATE: 'settings.billing-address.update',
  // SETTINGS_BILLING_ADDRESS_VIEW: 'settings.billing-address.view',
  // SETTINGS_CALLER_ID_VIEW: 'settings.caller-id.view',
  SETTINGS_AUTO_RECHARGE_VIEW: 'settings.auto-recharge.view',
  SETTINGS_AUTO_RECHARGE_TOGGLE: 'settings.auto-recharge.toggle',
  SETTINGS_BLOCK_LISTS_LIST: 'settings.block-lists.list',
  SETTINGS_BLOCK_LISTS_UNBLOCK: 'settings.block-lists.unblock',
  SETTINGS_CALLER_ID_DELETE: 'settings.caller-id.delete',
  SETTINGS_CALLER_ID_LIST: 'settings.caller-id.list',
  SETTINGS_CALLER_ID_UPDATE: 'settings.caller-id.update',
  SETTINGS_CALLER_ID_VERIFY: 'settings.caller-id.verify',
  SETTINGS_INTEGRATIONS_INTEGRATE: 'settings.integrations.integrate',
  SETTINGS_INTEGRATIONS_REVOKE: 'settings.integrations.revoke',
  SETTINGS_INTEGRATIONS_UPDATE: 'settings.integrations.update',
  SETTINGS_INTEGRATIONS_VIEW: 'settings.integrations.view',
  SETTINGS_MEMBERS_ASSIGN_NUMBER: 'settings.members.assign-number',
  SETTINGS_MEMBERS_CHANGE_ROLE: 'settings.members.change-role',
  SETTINGS_MEMBERS_DELETE_MEMBER: 'settings.members.delete-member',
  SETTINGS_MEMBERS_INVITE_MEMBERS: 'settings.members.invite-members',
  SETTINGS_MEMBERS_LIST: 'settings.members.list',
  SETTINGS_MEMBERS_RESEND_INVITE: 'settings.members.resend-invite',
  SETTINGS_MEMBERS_REVOKE_INVITATION: 'settings.members.revoke-invitation',
  SETTINGS_MY_ACCOUNT_CHANGE_PASSWORD: 'settings.my-account.change-password',
  SETTINGS_MY_ACCOUNT_DETAIL: 'settings.my-account.detail',
  SETTINGS_MY_ACCOUNT_UPDATE: 'settings.my-account.update',
  SETTINGS_CALL_FLOWS_VIEW: 'settings.call-flows.view',
  SETTINGS_CALL_FLOWS_LIST: 'settings.call-flows.list',
  SETTINGS_MY_NUMBERS_PURCHASE_NUMBER: 'settings.my-numbers.purchase-number',
  // SETTINGS_MEMBERS_VIEW: 'settings.members.view',
  SETTINGS_MEMBERS_VIEW_ASSIGN_NUMBERS: 'settings.members.view-assign-numbers',
  // SETTINGS_MY_ACCOUNT_CHANGE_EMAIL: 'settings.my-account.change-email',
  // SETTINGS_MY_NUMBER_TOGGLE: 'settings.my-number.toggle',
  // SETTINGS_MY_NUMBER_VIEW: 'settings.my-number.view',
  // SETTINGS_MY_NUMBERS_ALWAYS_FORWARD_TO_EXTERNAL_NUMBER: 'settings.my-numbers.always-forward-to-external-number',
  // SETTINGS_MY_NUMBERS_CALL_TRANSFER_SETTING: 'settings.my-numbers.call-transfer-setting',
  // SETTINGS_MY_NUMBERS_FORWARD_TO_EXTERNAL_NUMBER_IF_UNANSWERED:
  //   'settings.my-numbers.forward-to-external-number-if-unanswered',
  // SETTINGS_MY_NUMBERS_INTERACTIVE_VOICE_RESPONSE: 'settings.my-numbers.interactive-voice-response',
  // SETTINGS_MY_NUMBERS_VIEW: 'settings.my-numbers.view',
  SETTINGS_NOTIFICATION_TOGGLE: 'settings.notification.toggle',
  // SETTINGS_NOTIFICATION_VIEW: 'settings.notification.view',
  // SETTINGS_NUMBER_SETTING_AUDIO_AND_VOICEMAIL: 'settings.number-setting.audio-and-voicemail',
  SETTINGS_NUMBER_SETTING_AUTO_RECORD: 'settings.number-setting.auto-recording',
  SETTINGS_NUMBER_SETTING_AUTO_TRANSCRIBE: 'settings.number-setting.auto-transcribe',
  // SETTINGS_NUMBER_SETTING_CREATE_BUSINESS_HOURS: 'settings.number-setting.create-business-hours',
  // SETTINGS_NUMBER_SETTING_CREATE_SAVE_REPLIES: 'settings.number-setting.create-save-replies',
  // SETTINGS_NUMBER_SETTING_DELETE_SAVE_REPLIES: 'settings.number-setting.delete-save-replies',
  // SETTINGS_NUMBER_SETTING_ENABLE_VOICE_MAIL_EMAIL: 'settings.number-setting.enable-voice-mail-email',
  SETTINGS_NUMBER_SETTING_RELEASE: 'settings.number-setting.release',
  SETTINGS_NUMBER_SETTING_UPDATE: 'settings.number-setting.update',
  // SETTINGS_NUMBER_SETTING_UPDATE_SAVE_REPLIES: 'settings.number-setting.update-save-replies',
  // SETTINGS_NUMBER_SETTING_VIEW: 'settings.number-setting.view',
  // SETTINGS_NUMBER_SETTING_VIEW_BUSINESS_HOURS: 'settings.number-setting.view-business-hours',
  // SETTINGS_NUMBER_SETTING_VIEW_SAVE_REPLIES: 'settings.number-setting.view-save-replies',
  // SETTINGS_NUMBER_SETTING_VOICEMAIL: 'settings.number-setting.voicemail',

  // SETTINGS_OVERVIEW_UPDATE: 'settings.overview.update',
  SETTINGS_PAYMENT_VIEW: 'settings.payment.view',
  // SETTINGS_RECEIPT_EXPORT: 'settings.receipt.export',
  // SETTINGS_RECEIPT_VIEW: 'settings.receipt.view',
  // SETTINGS_WALLET_IMPORT: 'settings.wallet.import',
  SETTINGS_OVERVIEW_DETAIL: 'settings.overview.detail',
  SETTINGS_PAYMENT_METHOD_VIEW: 'settings.payment.view',
  SETTINGS_PAYMENT_ADD: 'settings.payment.add',
  SETTINGS_PAYMENT_DELETE: 'settings.payment.delete',
  SETTINGS_PAYMENT_SET_DEFAULT: 'settings.payment.set-default',
  SETTINGS_SUBSCRIPTION_CANCEL: 'settings.subscription.cancel',
  SETTINGS_SUBSCRIPTION_CHANGE: 'settings.subscription.change',
  SETTINGS_SUBSCRIPTION_VIEW: 'settings.subscription.view',
  SETTINGS_WALLET_VIEW: 'settings.wallet.view',
  SETTINGS_MYWORKSPACE_SETPREFEREDCONTACT: 'settings.my-workspace.set-preferred-contact',

  BULK_MESSAGING_CAMPAIGNS_CREATE: 'bulk-messaging.bulk-messaging-campaigns.create',
  BULK_MESSAGING_CAMPAIGNS_VIEW: 'bulk-messaging.bulk-messaging-campaigns.view',
  BULK_MESSAGING_CAMPAIGNS_LIST: 'bulk-messaging.bulk-messaging-campaigns.list',
  BULK_MESSAGING_CAMPAIGNS_DELETE: 'bulk-messaging.bulk-messaging-campaigns.delete',
  BULK_MESSAGING_CAMPAIGNS_UPDATE: 'bulk-messaging.bulk-messaging-campaigns.update',
} as const;
